export default __webpack_public_path__ + "static/media/employeePhoto.5acc65c1.jpeg";